import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import {
  LoadingOverlay,
  LoadingSpinner,
  LoadingSpinnerIcon,
} from "../../../styles/loading";
import {
  Title,
  Description,
  EmailSpan,
  OtpInputContainer,
  ResendContainer,
  ResendText,
  ResendLink,
} from "../../../styles/OTPVerificationStep";
import { ErrorText } from "../../../styles/PersonalInfoStep";
import { ConfirmButton } from "../../../styles/ForgotPassword";
import { FormContainer } from "../../../styles/login";


import { getItem, setItemWithObject } from "../../../utils/cache/LocalStorage";
import { ALERT_MESSAGES, ALERT_TITLES } from "../../../constants";
import CustomOtpInput from "../../../components/common/CustomOtpInput";
import { POST } from "../../../services/HTTPServices";

interface EnterEmailProps {
  callback?: () => void;
}

const ForgotOTP = (props: EnterEmailProps) => {
  const navigate = useNavigate();
  const [otp, setOtp] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [countdown, setCountdown] = React.useState(30);
  const [showCountdown, setShowCountdown] = React.useState(true);

  useEffect(() => {
    const temp_email = getItem("forgot_email") || "";
    if (temp_email) {
      setEmail(temp_email);
    }
  }, []);

  const handleChangeOTP = async (event: any) => {
    await setOtp(event);
  };



  const alertMessage = (title: string, text: string) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: title,
        text: text,
        icon:
          title === "Error!"
            ? "error"
            : title === "Success!"
            ? "success"
            : "warning",
        confirmButtonText: "OK",
        reverseButtons: true,
      })
      .then((result: any) => {
        if (result.isConfirmed) {
        }
      });
  };

  const valid = () => {
    if (otp === "") return false;
    else return true;
  };

  const handleResend = async () => {
    setLoading(true);
    const url = "serviceprovider/ResendOTP";
    const payload = { email };
    const response = (await POST(url, payload, "provider")) as
      | { status: number; message: string }
      | undefined;

    setLoading(false);
    if (!response) {
      const errorMessage = "An unknown error occurred";
      alertMessage(ALERT_TITLES.ERROR, errorMessage);
      setErrorMessage(errorMessage);
      return;
    }

    if (response.status === 200) {
      alertMessage(ALERT_TITLES.SUCCESS, ALERT_MESSAGES.OTP_RESENT);
      setShowCountdown(true);
      setCountdown(30);
    } else if (response.status === 401) {
      navigate("/unauthorized-page");
    } else {
      alertMessage(ALERT_TITLES.ERROR, response.message);
      setErrorMessage(response.message);
    }
  };

  const confirm = async () => {
    if (!otp || otp.length < 6) {
      setErrorMessage("Please enter the 6-digit verification code.");
      return;
    }
    setErrorMessage("");

    if (valid()) {
      if (email && email !== "") {
        setLoading(false);
        setItemWithObject("forgot_obj", { email: email, otp: otp });
        navigate('/forgot-password/reset')      
      }
    }
  };

  return (
    <>
      {loading && (
        <LoadingOverlay>
          <LoadingSpinner>
            <LoadingSpinnerIcon />
          </LoadingSpinner>
        </LoadingOverlay>
      )}

      <FormContainer>
        <Title className="mt-16">Enter OTP</Title>
        <Description>
          An OTP is sent to your email <EmailSpan>{email}</EmailSpan>.
        </Description>
        <OtpInputContainer>
          <CustomOtpInput
            value={otp}
            onChange={handleChangeOTP}
            numInputs={6}
            separator={<span></span>}
            inputClassName="otp-input"
            isInputSecure={true}
            shouldAutoFocus={true}
            isInputNum={true}
          />
        </OtpInputContainer>
        <ResendContainer>
          <ResendText>Didn't receive the OTP?</ResendText>
          {showCountdown ? (
            <ResendLink $isActive={false}>Resend in {countdown}s</ResendLink>
          ) : (
            <ResendLink $isActive={true} onClick={handleResend}>
              Click here to send again
            </ResendLink>
          )}
        </ResendContainer>
        {errorMessage && (
          <ErrorText marginBottom="32px">{errorMessage}</ErrorText>
        )}
        <ConfirmButton disabled={!valid()} onClick={confirm}>
          Confirm
        </ConfirmButton>
      </FormContainer>
      </>
  );
};

export default ForgotOTP;
